import { render, staticRenderFns } from "./Minsal.vue?vue&type=template&id=5d86cb13&scoped=true&"
import script from "./Minsal.vue?vue&type=script&lang=js&"
export * from "./Minsal.vue?vue&type=script&lang=js&"
import style0 from "./Minsal.vue?vue&type=style&index=0&id=5d86cb13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d86cb13",
  null
  
)

export default component.exports